import { OrganizationTypeFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/** Тип подразделения — справочное значение. */
export function OrganizationType({
  data,
}: {
  data?: Hidable<OrganizationTypeFragment>;
}) {
  return (
    <Value data={data}>
      {(organization) => (
        <LocalizedName data={organization.organizationType.value} />
      )}
    </Value>
  );
}
